import React from "react";
import "./cardruko.scss";
import Crystall5images from "../../ruko/cardruko/tipe5";
import Crystall7images from "../../ruko/cardruko/tipe7";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowsUpDownLeftRight } from "@fortawesome/free-solid-svg-icons";
import { faHouse } from "@fortawesome/free-solid-svg-icons";
import { faBed } from "@fortawesome/free-solid-svg-icons";
import { faShower } from "@fortawesome/free-solid-svg-icons";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";

const cardruko = () => {
  const settings = {
    dots: true,
    arrows: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  const crystall5wa = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=6289510613901&text=Halo+della%20Saya%C2%A0bisa%20minta%20detail%20Katalog,%20Simulasi%20dan%20Promo%20terbaru%20ruko%20ini%20(Crystal+L5)%20https://marketingsummabekasi.id/&type=phone_number&app_absent=0";
    window.location.href = whatsappLink;
  };
  const crystall7wa = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=6289510613901&text=Halo+della%20Saya%C2%A0bisa%20minta%20detail%20Katalog,%20Simulasi%20dan%20Promo%20terbaru%20ruko%20ini%20(Crystal+L7)%20https://marketingsummabekasi.id/&type=phone_number&app_absent=0";
    window.location.href = whatsappLink;
  };

  return (
    <div className="container-card-ruko">
      <div className="kartu">
        <Slider {...settings}>
          {Crystall5images.map((image, index) => (
            <img
              className="kartugambar"
              key={index}
              src={image}
              alt={`Astha ${index + 1}`}
            />
          ))}
        </Slider>
        <div className="container-title-card">
          <div className="titlecard">
            <div className="judul-rumah">Crystal L5</div>
            <div className="sub-judul-rumah">Insentif Fee 60jt</div>
            {/* <div className="cicilan">
              <div className="angka">14,6 Juta/Bulan</div>
            </div> */}
          </div>
        </div>
        {/* <hr color="black" />
        <div className="gridspek">
          <FontAwesomeIcon icon={faArrowsUpDownLeftRight} />
          <span> : 66m²</span>
          <FontAwesomeIcon icon={faHouse} />
          <span> : 63m²</span>
          <FontAwesomeIcon icon={faShower} />
          <span>: 2</span>
        </div> */}
        <div className="containerwhatsapp">
          <button onClick={crystall5wa} className="whatsapp">
            <FontAwesomeIcon icon={faWhatsapp} /> Whatsapp
          </button>
        </div>
      </div>
      <div className="kartu">
        <Slider {...settings}>
          {Crystall7images.map((image, index) => (
            <img
              className="kartugambar"
              key={index}
              src={image}
              alt={`Astha ${index + 1}`}
            />
          ))}
        </Slider>
        <div className="container-title-card">
          <div className="titlecard">
            <div className="judul-rumah">Crystal L7</div>
            <div className="sub-judul-rumah">Insentif Fee 180jt</div>
            {/* <div className="cicilan">
              <div className="angka">33,4 Juta/Bulan</div>
            </div> */}
          </div>
        </div>
        {/* <hr color="black" />
        <div className="gridspek">
          <FontAwesomeIcon icon={faArrowsUpDownLeftRight} />
          <span> : 77m²</span>
          <FontAwesomeIcon icon={faHouse} />
          <span> : 95m²</span>
          <FontAwesomeIcon icon={faBed} />
          <span>: 3+1</span>
          <FontAwesomeIcon icon={faShower} />
          <span>: 3+1</span>
        </div> */}
        <div className="containerwhatsapp">
          <button onClick={crystall7wa} className="whatsapp">
            <FontAwesomeIcon icon={faWhatsapp} /> Whatsapp
          </button>
        </div>
      </div>
    </div>
  );
};

export default cardruko;
